import { z } from 'zod'
import { ComparisonSchema } from '@omnea-app/packages/universal/conditionality/schema'

const QuestionComputationFunctionNameSchema = z.enum(['WeightedAverage'])
export type QuestionComputationFunctionName = z.infer<typeof QuestionComputationFunctionNameSchema>

const StaticComputationArgSchema = z.object({ sourceType: z.literal('static'), value: z.string() })

const QuestionComputationArgSchema = z.discriminatedUnion('sourceType', [
  z.object({ sourceType: z.literal('form-field'), sourceId: z.string() }),
  StaticComputationArgSchema,
])
export type QuestionComputationArg = z.infer<typeof QuestionComputationArgSchema>

const FunctionComputationSchema = z.object({
  kind: z.literal('function'),
  functionName: QuestionComputationFunctionNameSchema,
  args: z.array(QuestionComputationArgSchema),
})
export type FunctionComputation = z.infer<typeof FunctionComputationSchema>

const SwitchComputationSchema = z.object({
  kind: z.literal('switch'),
  branches: z.array(z.object({ id: z.string(), when: ComparisonSchema, then: StaticComputationArgSchema })).min(1),
})
export type SwitchComputation = z.infer<typeof SwitchComputationSchema>

export const QuestionComputationSchema = z.discriminatedUnion('kind', [FunctionComputationSchema, SwitchComputationSchema])
export type QuestionComputation = z.infer<typeof QuestionComputationSchema>
